const config = {
  breakpoints: ['40rem', '52rem', '64rem', '96rem', '128rem'],
  text: {
    xs: {},
    normal: {
      // p
      fontSize: ['1rem', null, '1.125rem', '1.25rem'],
    },
    lg: {
      // h4
      fontSize: ['1.5rem', null, null, '1.75rem'],
    },
    xl: {
      // h3
      fontSize: ['1.75rem', null, '2rem', '3.125rem'],
    },
  },
};

export default config;
